import { render } from "./TasksConfigModal.vue?vue&type=template&id=23ea6568&scoped=true&ts=true"
import script from "./TasksConfigModal.vue?vue&type=script&lang=ts"
export * from "./TasksConfigModal.vue?vue&type=script&lang=ts"

import "./TasksConfigModal.vue?vue&type=style&index=0&id=23ea6568&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ea6568"]])

export default __exports__